<template>
    <div class="panel">
        <transition name="fade" mode="out-in" appear>
            <img v-if="currentImage" v-bind:src="currentImageSrc" v-bind:key="currentImage">
        </transition>
    </div>
</template>

<script>
    export default {
        name: 'QA_panel',
        created: function() {
            var self = this;
            self.$root.$on('qa-question', function(subject) {
                self.currentImage = subject;
            });
        },
        data: function() {
            return {
                currentImage: null
            }
        },
        computed: {
            currentImageSrc: function() {
                return require('@/assets/images/qa_graphics/' + this.currentImage + '.png');
            }
        }
    }
</script>

<style scoped lang="stylus">
.panel
    text-align: center
    .fade-enter-active, .fade-leave-active
        transition: opacity 0.5s
    .fade-enter, .fade-leave-to
        opacity: 0
</style>